import { captureException, startSpan } from "@sentry/react";

import {
    EditNPCGenerationRequest,
    IGenerateImageResponse,
    INPCGenerationResponse,
    NPCGenerationRequest,
    NPCGenerationResponseDTO,
} from "../../types";
import { doGet, doPost, doPostJson, doPutJson } from "../core/http";

// NPC Image Generation
export const generateNpcImage = async (
    dataPayload: FormData,
    isPremium: boolean = false
): Promise<IGenerateImageResponse> => {
    const url = isPremium
        ? "/v1/npc/image/premium/generate"
        : "/v1/npc/image/generate";

    try {
        const { data, error } = await startSpan(
            { name: "generateNpcImage" },
            () => {
                return doPost(url, true, dataPayload);
            }
        );

        if (error) {
            captureException(error);
            return { error: error.message };
        }

        return { requestId: data };
    } catch (e) {
        captureException(e);
        if (e === "User is not logged in.") {
            return { error: e };
        }
        return { error: "Failed to create NPC image." }; // More specific error
    }
};

// NPC Generation & Fetching
export const generateNPC = async (
    npcData: NPCGenerationRequest
): Promise<INPCGenerationResponse> => {
    try {
        const { data, error } = await startSpan(
            { name: "generateNPC" },
            async () => {
                return await doPostJson("/api/npc/generate", true, npcData);
            }
        );

        if (error) {
            captureException(error);
            return { error: error.message };
        }

        return { response: data };
    } catch (e) {
        captureException(e);
        return { error: "Failed to generate NPC." };
    }
};

export const getNPC = async (id: string): Promise<INPCGenerationResponse> => {
    try {
        const response = await startSpan({ name: "getNPC" }, async () => {
            return await doGet(`/api/npc/${id}`, true);
        });

        if (response.error) {
            captureException(response.error);
            return { error: response.error };
        }

        return { response: response.data };
    } catch (e) {
        captureException(e);
        return { error: "Failed to get npc." };
    }
};

export const editNPC = async (
    id: string,
    npcData: EditNPCGenerationRequest
): Promise<{ response?: NPCGenerationResponseDTO; error?: string }> => {
    try {
        const { data, error } = await startSpan(
            { name: "editNPC" },
            async () => {
                return await doPutJson(`/api/npc/${id}`, true, npcData);
            }
        );

        if (error) {
            captureException(error);
            return { error: error.message };
        }

        return { response: data };
    } catch (error: any) {
        captureException(error);
        return { error: error.message };
    }
};
